export default __webpack_public_path__ + "static/media/job_offer2_xl.01fb887c.jpg";